import React, { forwardRef, Ref } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { Switch, SwitchProps } from '@material-ui/core'
import clsx from 'clsx'

export type IOSSwitchProps =
  Omit<SwitchProps, 'classes' | 'disableRipple' | 'focusVisibleClassName'>

export const IOSSwitch =
  forwardRef(
    (props: IOSSwitchProps, ref: Ref<HTMLButtonElement>) => {
      const classes = useStyles()

      return (
        <Switch
          ref={ref}
          disableRipple
          focusVisibleClassName={classes.focusVisible}
          classes={{
            root: classes.root,
            switchBase: clsx(classes.switchBase,
              props.readOnly && classes.switchBaseReadOnly,
              props.disabled && classes.switchBaseDisabled),
            thumb: classes.thumb,
            track: classes.track,
            checked: classes.checked
          }}
          {...props}
        />
      )
    })

const useStyles = makeStyles(
  theme => ({
    root: {
      width: 35,
      height: 18,
      padding: 0,
      margin: theme.spacing(1)
    },
    switchBase: {
      padding: 1,
      '&$checked': {
        transform: 'translateX(17px)',
        color: theme.palette.common.white,
        '& + $track': {
          backgroundColor: '#3987CF',
          opacity: 1,
          border: 'none'
        }
      }
    },
    switchBaseDisabled: {
      cursor: 'not-allowed'
    },
    switchBaseReadOnly: {
      cursor: 'initial'
    },
    thumb: {
      width: 16,
      height: 16
    },
    track: {
      borderRadius: 20 / 2,
      backgroundColor: '#D7E7F5',
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border'])
    },
    checked: {},
    focusVisible: {}
  }))